import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=c35bf5d0&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=c35bf5d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35bf5d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35bf5d0')) {
      api.createRecord('c35bf5d0', component.options)
    } else {
      api.reload('c35bf5d0', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=c35bf5d0&scoped=true", function () {
      api.rerender('c35bf5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/enterprise/list/components/formBox.vue"
export default component.exports